module.exports = __webpack_public_path__ + "static/img/site-7.a1ae8dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/site-7.png
// module id = w/Zm
// module chunks = 0